{
  "create_new_schedule": "Crie um novo cronograma",
  "copy_schedule_alert": "Pode levar alguns minutos para copiar os dados do cronograma",
  "manage_schedule_settings": "Gerenciar configurações de agendamento",
  "all_venues": "Todos os locais",
  "no_venues": "Sem locais",
  "x_venues_selected": "{{ count }} locais selecionados",
  "view_by": "Exibir por",
  "day": "Dia",
  "venue": "Local",
  "cluster": "Cluster",
  "no_space_defined": "Nenhum espaço definido",
  "no_sessions_in_view": "Nenhuma sessão nesta visualização",
  "discipline": "A disciplina",
  "day_discipline": "Dia (Disciplina)",
  "day_venue": "Dia (Local)",
  "daily_run_sheet": "Planilha de execução diária",
  "venue_run_sheet": "Planilha de execução do local",
  "DCAS": "DCAS",
  "summary": "Resumo",
  "show_scheduled_items": "Mostrar itens agendados",
  "hide_scheduled_items": "Ocultar itens agendados",
  "show_sessions": "Mostrar sessões",
  "hide_sessions": "Ocultar sessões",
  "error_loading_schedule": "Algo deu errado ao carregar a programação",
  "schedule": "Cronograma",
  "save_schedule": "salvar agenda",
  "delete_schedule": "excluir agenda",
  "create_schedule_form": {
    "create_new_schedule": "Crie um novo cronograma",
    "name_field_label": "Nome do novo cronograma",
    "status_field_label": "Definir o status da nova programação",
    "status_field_options": {
      "draft_label": "Esboço",
      "draft_description": "Agenda visível somente para aqueles nomeados nas configurações de permissão",
      "published_label": "Publicado",
      "published_description": "Visível para todos"
    },
    "copy_versions_label": "Selecione os cronogramas disciplinares que você gostaria de copiar para esse novo cronograma"
  },
  "create_sub_schedule_form": {
    "create_new_sub_schedule": "Crie um novo cronograma {{ subSchedule }}",
    "parent_schedule": "Agenda dos pais",
    "new": "Novo",
    "copy_existing": "Cópia do existente",
    "name_of_calendar": "Nome do calendário",
    "selectSubSchedulesToCopy": "Selecione os {{ scheduleVersionType }} (s) que você gostaria de copiar"
  },
  "edit_schedule_form": {
    "edit_schedule": "Gerenciar configurações de agendamento",
    "name_field_label": "Nome do cronograma",
    "status_field_label": "Definir o status da programação"
  },
  "edit_schedule_data_options": {
    "title": "Editar opções de dados do cronograma"
  },
  "add_data_fields_form": {
    "add_datafield_list_items": "Adicionar itens da lista de atributos",
    "download_template": "Baixe o modelo CSV",
    "upload": "Carregar CSV",
    "venue_location": "Localização do local"
  },
  "settings": "configurações",
  "visibility": "visibilidade",
  "create_session_form": {
    "create_new_session": "Criar nova sessão",
    "ticketedDescription": "Sessão marcada como emitida por padrão",
    "headings": {
      "formTitleNew": "Nova sessão",
      "formTitleEdit": "Editar sessão",
      "details": "Detalhes",
      "time": "Horários da sessão",
      "venue": "Local",
      "events": "Eventos nesta sessão",
      "type": "Estilo de sessão",
      "entry": "Entrada e transmissão",
      "ticketingAndBroadcasting": "Bilheteria e transmissão",
      "ticketed": "Ingressado"
    },
    "inputLabels": {
      "code": "Código da sessão",
      "style": "Estilo de sessão",
      "description": "Descrição da sessão (opcional)",
      "day": "Dia",
      "spare": "Use como dia livre",
      "sTime": "Hora de início",
      "eTime": "Hora de término",
      "zTime": "Tempo zero",
      "zeroCheckBoxLabel": "Igual ao horário de início da sessão",
      "estimated": "Fim estimado",
      "duration": "Duração (minutos)",
      "ticketed": "Sessão com ingresso"
    },
    "buttons": {
      "addEvent": "Adicionar um evento",
      "addAnother": "Adicionar outro evento",
      "removeEvent": "Remover evento",
      "addPhase": "Adicionar fase",
      "addAnotherPhase": "Adicionar outra fase",
      "cancel": "Cancelar",
      "save": "Salvar",
      "delete_session": "Excluir sessão"
    },
    "delete": {
      "title": "Excluir sessão",
      "message": "A exclusão desta sessão também excluirá seus itens agendados e quaisquer atividades que estejam especificamente relacionadas a ela. Deseja continuar?",
      "confirm": "Confirmar",
      "cancel": "Cancelar"
    }
  },
  "summary_grid": {
    "venue": "Local",
    "discipline": "Discipl"
  },
  "scheduled_item": {
    "CREATE": "Novo item agendado",
    "EDIT": "Editar item agendado",
    "within_event": "Dentro do evento",
    "delete_item": "Excluir item",
    "venue": "Local",
    "space": "Espaço",
    "time": "Hora",
    "location": "Localização",
    "delete": {
      "title": "Excluir item agendado",
      "message": "Você tem certeza?",
      "confirm": "Confirme",
      "cancel": "Cancelar"
    },
    "time_type": {
      "not_before": {
        "name": "Não antes",
        "description": "O item agendado não começará antes da hora de início indicada."
      },
      "followed_by": {
        "name": "Seguido por",
        "description": "A hora de início depende da hora de término do item agendado anterior."
      }
    },
    "estimated_duration": "Duração estimada",
    "estimated_duration_description": "A duração exata do item agendado não é certa.",
    "save_and_next": "Salvar e próximo",
    "save_and_finish": "Salvar e finalizar"
  },
  "session_card": {
    "day": "Dia",
    "start_time": "Hora de início",
    "end_time": "Hora de término",
    "duration": "Duração",
    "medal_session": "Sessão de medalhas",
    "add_scheduled_item": "Adicionar item agendado",
    "scheduled_items_in_session": "Itens agendados na sessão",
    "events_in_session": "Eventos em sessão",
    "close_popup": "Fechar pop-up",
    "edit": "Editar",
    "zero_time": "Tempo zero",
    "no_space": "Sem espaço",
    "in": "Em",
    "show_more": "Mostrar mais",
    "show_less": "Mostrar menos"
  }
}